
import React from 'react';
import { Button } from '@/components/ui/button';
import { Phone } from 'lucide-react';
import MixpanelService from '@/services/mixpanel';

interface TalkToSalesProps {
  className?: string;
  buttonText?: string;
  calendlyUrl?: string;
}

const TalkToSales: React.FC<TalkToSalesProps> = ({ 
  className = '',
  buttonText = 'Talk to sales',
  calendlyUrl = 'https://calendly.com/tastermonial'
}) => {
  const handleClick = () => {
    // Track the button click
    MixpanelService.trackButtonClick('Talk to Sales', {
      calendlyUrl: calendlyUrl
    });
    
    // Open the calendly URL
    window.open(calendlyUrl, '_blank');
  };

  return (
    <Button 
      className={`bg-[#fbce57] hover:bg-[#ebc24f] text-black font-medium ${className}`}
      onClick={handleClick}
    >
      <Phone className="mr-2 h-4 w-4" />
      {buttonText}
    </Button>
  );
};

export default TalkToSales;
